module.exports = __webpack_public_path__ + "static/media/dots.1a0ac942.svg";